import "./AvatarButton.scss";
import { Avatar, IconButton, Typography } from "@mui/material";

import makeStyles from '@mui/styles/makeStyles';

import CloseIcon from '@mui/icons-material/Close';

const useStyles = makeStyles(theme => ({
    avatar: {
        color: '#fafafa',
        background: '#121212',
    },
    avatarActive: {
        color: '#000',
        background: '#D09705',
    },
    avatarIcon: {
        color: 'inherit',
    },
}));

export default function AvatarButton({ user, onClick = () => {}, active = false, buttonRef }) {
    const classes = useStyles();

    const label = user ? user.firstName[0] + user.lastName[0] : "...";

    return (
        <Avatar
            className={`AvatarButton ${classes.avatar} ${active ? classes.avatarActive : ''}`}
        >
            <IconButton
                onClick={onClick}
                ref={buttonRef}
                className={`AvatarButton__iconbtn ${classes.avatarIcon}`}
                size="large">
                {!active ? (
                    <Typography variant="button">
                        {label.toLocaleUpperCase()}
                    </Typography>
                ) : (
                    <CloseIcon />
                )}
            </IconButton>
        </Avatar>
    );
}